module.exports = __webpack_public_path__ + "img/Polish Marks.29cbb3e1.png";